import { useState } from "react";
import { Plus, PencilSimple, Trash, Check, X } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

function RoleRow({ role, onSaved }) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(role.name);
  const save = async () => {
    try {
      await api.put(`/roles/${role.id}`, { name });
      toast.success("Rol actualizado");
      setEditing(false);
      onSaved();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const del = async () => {
    if (!window.confirm(`¿Borrar el rol "${role.name}"?`)) return;
    try {
      await api.delete(`/roles/${role.id}`);
      toast.success("Rol borrado");
      onSaved();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-xl border border-[var(--border)] bg-white" data-testid={`role-row-${role.id}`}>
      {editing ? (
        <input value={name} onChange={(e) => setName(e.target.value)} className="form-input py-1 text-sm" data-testid={`role-name-input-${role.id}`} autoFocus />
      ) : (
        <span className="font-display font-semibold text-sm">{role.name}</span>
      )}
      <span className="text-xs text-[var(--text-secondary)] whitespace-nowrap" data-testid={`role-users-${role.id}`}>{role.users} trab.</span>
      {editing ? (
        <>
          <button type="button" onClick={save} className="p-1.5 rounded-lg hover:bg-[var(--bg)]" data-testid={`role-save-${role.id}`}><Check size={14} /></button>
          <button type="button" onClick={() => { setEditing(false); setName(role.name); }} className="p-1.5 rounded-lg hover:bg-[var(--bg)]"><X size={14} /></button>
        </>
      ) : (
        <>
          <button type="button" onClick={() => setEditing(true)} className="p-1.5 rounded-lg hover:bg-[var(--bg)]" data-testid={`role-edit-${role.id}`}><PencilSimple size={14} /></button>
          <button type="button" onClick={del} className="p-1.5 rounded-lg hover:bg-red-50 hover:text-red-700" data-testid={`role-delete-${role.id}`}><Trash size={14} /></button>
        </>
      )}
    </div>
  );
}

export default function AdminRolesManager({ roles, reload }) {
  const [name, setName] = useState("");
  const create = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post("/roles", { name: name.trim() });
      toast.success("Rol creado");
      setName("");
      reload();
    } catch (e2) { toast.error(formatApiError(e2)); }
  };
  return (
    <div className="card-flat p-6 mb-6" data-testid="roles-manager">
      <div className="label-cap mb-1">roles de trabajador</div>
      <p className="text-sm text-[var(--text-secondary)] mb-4">
        Crea los tipos de trabajador. Se usan para la visibilidad de tareas y los grupos del panel de horas. Admin es un rol especial que ve todo.
      </p>
      <div className="flex flex-wrap gap-2 mb-4">
        {roles.map((r) => <RoleRow key={`${r.id}-${r.name}`} role={r} onSaved={reload} />)}
      </div>
      <form onSubmit={create} className="flex items-center gap-2 max-w-md">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nuevo rol (ej. Ayudante cocina)" className="form-input flex-1" data-testid="role-new-input" />
        <button type="submit" disabled={!name.trim()} className="btn-primary px-4 py-2 rounded-xl font-display font-bold inline-flex items-center gap-2 disabled:opacity-50" data-testid="role-new-submit">
          <Plus size={16} weight="bold" /> Añadir
        </button>
      </form>
    </div>
  );
}
